import { Component, HostListener, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { Product } from '@kion/data-models';
import SwiperCore, {
  Navigation,
  Pagination,
  Autoplay
} from 'swiper/core';
import { BehaviorSubject } from 'rxjs';
import { SubSink } from 'subsink';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { CmsConfig } from '../../../../../cms/src/lib/config/cms.config';
import { DOCUMENT } from '@angular/common';

SwiperCore.use([Navigation, Pagination, Autoplay]);

@Component({
  selector: 'kion-product-slider',
  templateUrl: './product-slider.component.html',
  styleUrls: ['./product-slider.component.scss']
})
export class ProductSliderComponent implements OnInit, OnDestroy{
  @Input() products: Product[];

  groupSize = 4;
  windowSize$: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  private subSink: SubSink;
  private readonly window: Window;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private cmsConfig: CmsConfig,
    @Inject(DOCUMENT
  ) private document: Document) {
    this.window = this.document.defaultView;
    this.subSink = new SubSink();
    this.subSink.sink = this.router.events.subscribe(
      events => {
        if (events instanceof NavigationEnd) {
          // @ts-ignore
          const url = this.route.snapshot._routerState.url;
          if (this.route.snapshot.data.pdp && url.indexOf(this.cmsConfig.routes?.productBaseRoute) !== -1) {
            this.window.location.reload();
          }
        }
      }
    )
  }


  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.windowSize$.next(event.target.innerWidth);
  }

  ngOnInit(): void {
    this.windowSize$.next(window.innerWidth);
    this.subSink.sink = this.windowSize$
      .subscribe(
        (windowSize: number) => {
          //if windowSize is below 768, set groupSize to 1
          this.groupSize = 4;
          if (windowSize <= 1024) {
            this.groupSize = 3;
          }
          if (windowSize <= 768) {
            this.groupSize = 2;
          }
        }
      );
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }
}
